export default __webpack_public_path__ + "static/dashboard.fr-c8c121d017413f6d12fdf53af0a656af.svg";